import type { FloodCalibrationZoneRegion } from '@/features/map/utils/vietnamFloodScenarioCalibration';

/**
 * Suy luận miền căn chỉnh từ nhãn vùng (polygon / sidebar) — dùng chung cho lưới và KPI độ sâu.
 */
export function inferCalibrationRegionFromRegionLabel(name: string): FloodCalibrationZoneRegion {
  const n = name.toLowerCase();
  if (
    n.includes('huế') ||
    n.includes('đà nẵng') ||
    n.includes('trung bộ') ||
    n.includes('hue') ||
    n.includes('da nang')
  ) {
    return 'central';
  }
  if (
    n.includes('cần thơ') ||
    n.includes('hồ chí minh') ||
    n.includes('tp.hcm') ||
    n.includes('đbscl') ||
    n.includes('sài gòn') ||
    n.includes('hcm')
  ) {
    return 'south';
  }
  if (
    n.includes('gia lai') ||
    n.includes('đắk lắk') ||
    n.includes('tây nguyên') ||
    n.includes('đắk nông')
  ) {
    return 'highlands';
  }
  return 'north';
}
